<template>
<div class="panel bgPanel mt1x pb1x h21x">
	<div class="title title-bg">
		<span :title="$t('plant_detail82',['节能减排及收入'])">{{$t("plant_detail82",["节能减排及收入"])}}</span>
	</div>
	<loading v-show="isLoading"></loading>
	<div class="tableSys" v-if="JSON.stringify(stationInfo)!='{}'">
		<div class="w50pct_E fL_E vaM vaM_E h15x pl05x pr05x clearfix">
			<div class="taC mb2x">
				<div class="pl05x pr05x dpIB_E">
					<div class="icoSys h4x w4x dpIB">
						<svg class="ico fBlue"><use xlink:href="#coal"></use></svg>
					</div>
					<div class="w70pct-max">
						<div class="mb1x" :title="`${floatFix(stationInfo.generationUploadTotalOffset*0.0004,2)}`"><span class="fs14x">{{floatFix(stationInfo.generationUploadTotalOffset*0.0004,2)}}</span> T</div>
						<div class="cSub">{{getLanguageStr('word1526','节约标准煤')}}</div>
					</div>
				</div>
			</div>
			<div class="taC mb2x">
				<div class="pl05x pr05x dpIB_E">
					<div class="icoSys h4x w4x dpIB">
						<svg class="ico fYellow"><use xlink:href="#CO2"></use></svg>
					</div>
					<div class="w70pct-max">
						<div class="mb1x" :title="`${floatFix(stationInfo.generationUploadTotalOffset*0.000997,2)}`"><span class="fs14x">{{floatFix(stationInfo.generationUploadTotalOffset*0.000997,2)}}</span> T</div>
						<div class="cSub">{{getLanguageStr('device_record12','CO₂减排量')}}</div>
					</div>
				</div>
			</div>
			<div class="taC">
				<div class="pl05x pr05x dpIB_E">
					<div class="icoSys h4x w4x dpIB">
							<svg class="ico fGreen"><use xlink:href="#tree"></use></svg>
					</div>
					<div class="w70pct-max">
						<div class="mb1x" :title="`${floatFix(stationInfo.generationUploadTotalOffset*0.997/365,2)}`"><span class="fs14x">{{floatFix(stationInfo.generationUploadTotalOffset*0.997/365,2)}}</span> {{getLanguageStr('unit36','棵')}}</div>
						<div class="cSub">{{getLanguageStr('word1551','等效植树量')}}</div>
					</div>
				</div>
			</div>
			<div class="taC">
				<div class="pl05x pr05x dpIB_E">
					<div class="icoSys h4x w4x dpIB">
						<svg class="ico fGreen"><use xlink:href="#totalIncome"></use></svg>
					</div>
					<div class="w70pct-max">
						<div class="mb1x" :title="convertData(stationInfo.incomeUploadOffset,2,'',stationInfo.currency)[0]">
							<span class="fs14x">{{convertData(stationInfo.incomeUploadOffset,2,'',stationInfo.currency)[1]}}</span><span v-if="stationInfo.incomeUploadOffset"> {{convertData(stationInfo.incomeUploadOffset,2,'',stationInfo.currency)[2]}}</span>
						</div>
						<div class="cSub">{{getLanguageStr('word726','累计收入')}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import {getLanguageStr} from '@/util/language.js'
import * as equipmentApi from '@/api/maintain/plant/list'
import Loading from '@/components/common/ui/Loading'
import * as lib from '@/util/lib.js'
export default {
	name: 'saveEnegy',
	components: {Loading},
	data () {
		return {
			isLoading: false,
			stationInfo: {},
			stage
		}
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		// Moneyfix: lib.Moneyfix,
		show (data) {
			this.isLoading = true
			if (data.stationInfo) {
				this.stationInfo = data.stationInfo
				setTimeout(() => {
					this.isLoading = false
				}, 500)
			} else {
				if (data.level == 0) {
					this._getList(data.stationId)
				} else {
					this._getList(data.systemId)
				}
			}
		},
		_getList (id) {
			this.isLoading = true
			equipmentApi.StationInfo(id).then(res => {
				this.isLoading = false
				this.stationInfo = res
			}, error => {
				this.isLoading = false
				!_.isEmpty(error) && this.$notify(error)
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/SaveEnergy.vue